import React from "react";
import PropTypes from "prop-types";
import {Box, CircularProgress} from "@mui/material";

import ProgressBarList from "components/ProgressBar/ProgressBarList";

import Title from "./components/Title";
import Subtitle from "./components/Subtitle";

import {blue500, greyishBlue100, greyishBlue500} from "assets/jss/main";
import {UserAgentUtils} from "utils/useragent";

const MAX_CATEGORIES = 7;

function CategoryBarChart({title, subtitle, categories, valueKey, formatValue, loading}) {
    const isMobile = UserAgentUtils.isMobile();

    const sorted = [...(categories ?? [])]
        .sort((a, b) => b[valueKey] - a[valueKey])
        .slice(0, MAX_CATEGORIES);

    const maxValue = sorted[0]?.[valueKey] ?? 0;

    return (
        <Box
            sx={{
                flex: 1,
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: `1px solid ${greyishBlue100}`,
                p: isMobile ? '16px' : '20px',
                minWidth: 0,
            }}
        >
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
            {loading ? (
                <Box sx={{display: "flex", justifyContent: "center", py: 4, mt: 4}}>
                    <CircularProgress size={24}/>
                </Box>
            ) : (
                <Box sx={{mt: 3}}>
                    <ProgressBarList
                        height={isMobile ? 8 : 12}
                        items={sorted.map(cat => ({
                            label: cat.name,
                            percentage: maxValue > 0 ? Math.round((cat[valueKey] / maxValue) * 100) : 0,
                            valueLabel: formatValue ? formatValue(cat[valueKey]) : cat[valueKey].toLocaleString(),
                            color: blue500,
                        }))}
                    />
                    {!sorted.length && (
                        <div style={{fontSize: "13px", color: greyishBlue500, textAlign: "center", padding: "16px 0"}}>
                            —
                        </div>
                    )}
                </Box>
            )}
        </Box>
    );
}

CategoryBarChart.propTypes = {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    categories: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        alertCount: PropTypes.number,
        lostRevenue: PropTypes.number,
    })),
    valueKey: PropTypes.string.isRequired,
    formatValue: PropTypes.func,
    loading: PropTypes.bool,
};

export default CategoryBarChart;
